export const BASE_URL = '/api/v1';
export const LOCAL_AUTH_KEY = 'authorisation';
